import React from 'react';

const INITIAL_STATE = {
    loja: {},
    modelos: [],
    folhas: [],
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'loja_modelo':
            return {
                ...state,
                loja: action.payload.loja,
                modelos: action.payload.modelos,
                folhas: action.payload.folhas,
            };
        default:
            return { ...state };
    }
};
